import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { appConfigService } from '@app/config';
import { JedinicaGradiva } from '@app/shared/models/jedinica-gradiva';
import {
  AuthRequestOptions,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { first } from 'rxjs';

@Component({
  selector: `app-odabir-jedinice-za-istaknuti-sadrzaj`,
  templateUrl: './odabir-jedinice-za-istaknuti-sadrzaj.component.html'
})
export class OdabirJediniceZaIstaknutiSadrzajComponent {
  public showDialog = false;

  private listviewProvider = inject(ListViewProviderDirective);
  private notificationService = inject(NotificationService);

  private httpClient = inject(HttpClient);
  private config = inject(appConfigService);

  public refresh() {
    this.listviewProvider.refresh();
  }

  public onSelectedItem(jedinice: JedinicaGradiva[]) {
    const formData = jedinice.map((jg) => jg['en~jedinica_gradiva~id']);

    this.httpClient
      .post(
        `${this.config.apiHost}istaknuti-sadrzaj`,
        formData,
        new AuthRequestOptions()
      )
      .pipe(first())
      .subscribe({
        next: () => {
          const message =
            jedinice.length > 1
              ? 'Jedinice gradiva uspješno dodane'
              : 'Jedinica gradiva uspješno dodana';
          this.notificationService.success(message);
          this.listviewProvider.refresh();
        },
        error: () => {
          const errorMessage =
            jedinice.length > 1
              ? 'Greška pri dodavanju jedinica gradiva'
              : 'Greška pri dodavanju jedinice gradiva';
          this.notificationService.error(errorMessage);
        },
        complete: () => {
          this.showDialog = false;
        }
      });

    this.showDialog = false;
  }
}
